<link
  *ngIf="dynamicFlag"
  type="text/css"
  rel="stylesheet"
  href="/css/highcontrast.css"
/>
<link
  *ngIf="!dynamicFlag"
  type="text/css"
  rel="stylesheet"
  href="/css/normalcontrast.css"
/>
<link
  *ngIf="rowNumbering"
  type="text/css"
  rel="stylesheet"
  href="/css/row-numbering.css"
/>

<router-outlet></router-outlet>
